angular.module('gym.calendar').controller('ChangeWeeklySessionTimeCtrl', ["$scope", "$rootScope", "$modal", "$modalInstance", "EditEventService", "EditEventScheduleService", "ConfirmLeaveUnsavedChangesService", "params", function($scope, $rootScope, $modal, $modalInstance, EditEventService, EditEventScheduleService, ConfirmLeaveUnsavedChangesService, params) {
  var copyDailySession, createDailySessionMoves, getDailySession, isSessionChanged, syncDailySessions;
  $scope.days = EditEventService.getDays();
  $scope.gym = $rootScope.gym;
  $scope.event = params.event;
  $scope.frequencyUpdateParams = {
    change_type: 'change_weekly_session_time',
    change_attributes: {}
  };
  ConfirmLeaveUnsavedChangesService.watch($scope, 'frequencyUpdateParams', {
    closeModal: function() {
      return $scope.close(true);
    }
  });
  $scope.onClose = function() {
    params.cancelEdit();
    return $modalInstance.dismiss('cancel');
  };
  $scope.close = function(skipConfirmation) {
    if ($scope.displayConfirmationOnClose && !skipConfirmation) {
      if (window.confirm("Are you sure? This will abandon any unsaved changes.")) {
        return $scope.onClose();
      }
    } else {
      return $scope.onClose();
    }
  };
  $scope.showChangeFrequencyForm = function() {
    $scope.close(true);
    return params.showChangeFrequencyForm();
  };
  createDailySessionMoves = function() {
    return _.mapObject($scope.event.daily_sessions, function(day, key) {
      return day.map(function(session) {
        return {
          start_at: session.start_at,
          end_at: session.end_at,
          reschedule_date: session.reschedule_date,
          moved_from: {
            wday: key,
            start_at: session.start_at,
            end_at: session.end_at
          }
        };
      });
    });
  };
  copyDailySession = function(withMoves) {
    var dailySessions, keysToOmit;
    keysToOmit = [];
    dailySessions = _.mapObject($scope.dailySessions, function(day, key) {
      var copyDay;
      copyDay = day.map(function(session) {
        var data;
        if (!isSessionChanged(session, session.moved_from, key) && withMoves) {
          return void 0;
        }
        data = {
          start_at: session.start_at,
          end_at: session.end_at,
          reschedule_date: session.reschedule_date
        };
        if (withMoves) {
          data.moved_from = session.moved_from;
        }
        return data;
      });
      if (!_.compact(copyDay).length) {
        keysToOmit.push(key);
      }
      return copyDay;
    });
    keysToOmit.forEach(function(key) {
      return delete dailySessions[key];
    });
    return dailySessions;
  };
  syncDailySessions = function() {
    return $scope.frequencyUpdateParams.change_attributes = {
      daily_sessions: copyDailySession(),
      daily_session_moves: copyDailySession(true)
    };
  };
  $scope.frequencyUpdateParams.change_attributes = {
    daily_sessions: $scope.event.daily_sessions,
    daily_session_moves: {}
  };
  $scope.dailySessions = createDailySessionMoves();
  $scope.isDaySelected = function(index) {
    var ref, ref1;
    return (ref = $scope.dailySessions) != null ? (ref1 = ref[index]) != null ? ref1.length : void 0 : void 0;
  };
  getDailySession = function(startTime = $scope.event.start_time) {
    return EditEventScheduleService.getDailySession($scope.event, startTime);
  };
  $scope.onDailySessionStartTimeChanged = function(session, dayIndex, sessionIndex) {
    angular.extend(session, getDailySession(session.start_at_obj));
    return syncDailySessions();
  };
  $scope.onDailySessionEndTimeChanged = function(session) {
    session.end_at = moment(session.end_at_obj).format('h:mma');
    return syncDailySessions();
  };
  isSessionChanged = function(session, movedFrom, dayIndex) {
    return session.start_at !== movedFrom.start_at || session.end_at !== movedFrom.end_at || session.reschedule_date !== movedFrom.reschedule_date || dayIndex !== movedFrom.wday;
  };
  $scope.parseDailySession = function(session) {
    if (session.start_at && session.end_at) {
      session.start_at_obj = moment(session.start_at, 'h:mma').toDate();
      return session.end_at_obj = moment(session.end_at, 'h:mma').toDate();
    }
  };
  $scope.moveSession = function(dayIndex, moveDayIndex, sessionIndex) {
    var ref, session;
    session = $scope.dailySessions[dayIndex].splice(sessionIndex, 1);
    $scope.dailySessions[moveDayIndex] = ((ref = $scope.dailySessions[moveDayIndex]) != null ? ref.length : void 0) ? $scope.dailySessions[moveDayIndex].concat(session) : session;
    if (!$scope.dailySessions[dayIndex].length) {
      delete $scope.dailySessions[dayIndex];
    }
    return syncDailySessions();
  };
  $scope.isFormReady = function() {
    return !$scope.isLoading;
  };
  $scope.save = function() {
    $scope.isLoading = true;
    return params.save($scope.frequencyUpdateParams).then(function() {
      return $scope.close(true);
    }, function() {
      return $scope.isLoading = false;
    });
  };
  return $scope.moveToADate = function(wday, dailySession, dayIndex, sessionIndex) {
    var modalInstance;
    modalInstance = $modal.open({
      template: require('templates/gyms/calendar/events/edit_event_schedule/reschedule_session_modal.html.slim'),
      size: 'lg',
      resolve: {
        wday: function() {
          return wday;
        },
        event: function() {
          return $scope.event;
        },
        dailySession: function() {
          return dailySession;
        },
        minDate: function() {
          return moment($scope.gym.today).endOf('isoWeek').add(1, 'days').toDate();
        },
        moveSession: function() {
          return $scope.moveSession;
        },
        dayIndex: function() {
          return dayIndex;
        },
        sessionIndex: function() {
          return sessionIndex;
        }
      },
      controller: ["$scope", "$modalInstance", "dailySession", "wday", "event", "minDate", "moveSession", "dayIndex", "sessionIndex", function($scope, $modalInstance, dailySession, wday, event, minDate, moveSession, dayIndex, sessionIndex) {
        $scope.wday = wday;
        $scope.event = event;
        $scope.minDate = minDate;
        $scope.dailySession = dailySession;
        $scope.dailySession.temp_reschedule_date = $scope.dailySession.reschedule_date;
        $scope.dailySession.reschedule_start_at_obj = $scope.dailySession.start_at_obj;
        $scope.dailySession.previous_reschedule_start_at_obj = $scope.dailySession.start_at_obj;
        $scope.dailySession.reschedule_end_at_obj = $scope.dailySession.end_at_obj;
        $scope.onStartTimeChange = function() {
          var diff, session;
          session = $scope.dailySession;
          diff = moment(session.reschedule_start_at_obj).diff(session.previous_reschedule_start_at_obj, 'minutes');
          session.previous_reschedule_start_at_obj = session.reschedule_start_at_obj;
          if (diff) {
            return session.reschedule_end_at_obj = moment(session.reschedule_end_at_obj).add(diff, 'minutes').toDate();
          }
        };
        $scope.isValid = function() {
          return dailySession.start_at_obj && dailySession.temp_reschedule_date;
        };
        $scope.cancel = function() {
          return $modalInstance.dismiss('cancel');
        };
        return $scope.submit = function() {
          dailySession.start_at_obj = dailySession.reschedule_start_at_obj;
          dailySession.start_at = moment(dailySession.reschedule_start_at_obj).format('h:mma');
          dailySession.end_at_obj = dailySession.reschedule_end_at_obj;
          dailySession.end_at = moment(dailySession.reschedule_end_at_obj).format('h:mma');
          dailySession.reschedule_date = dailySession.temp_reschedule_date;
          moveSession(dayIndex, moment(dailySession.reschedule_date).format('d'), sessionIndex);
          return $modalInstance.close();
        };
      }]
    });
    return modalInstance.result.then(function() {
      return syncDailySessions();
    });
  };
}]);
